/**
 * D-175: under a corrected task. « Votre enregistrement est inaudible », the one redo the server
 * offers (RedoTask), and a trainer's mark with their comment.
 */

import { markNote } from "@agencyos/core";
import { UserCheck } from "lucide-react";
import { useTranslation } from "react-i18next";
import { useParams } from "react-router-dom";

import { RedoTask } from "./RedoTask";

export function MarkNotes({ grade, productionId }: { grade: unknown; productionId?: string }) {
  const { t } = useTranslation();
  const { id: attemptId } = useParams();
  const note = markNote(grade);
  if (!note.unintelligible && !note.byTrainer) return null;
  return (
    <div className="stack">
      {note.unintelligible && (
        <p className="ac-note ac-note--warning" role="alert">
          {t("academy.results.unintelligible")}
        </p>
      )}
      {note.redoOffered && attemptId && productionId && <RedoTask attemptId={attemptId} productionId={productionId} />}
      {note.byTrainer && (
        <p className="ac-status">
          <UserCheck aria-hidden size={18} /> {t("academy.results.reviewedByTrainer")}
        </p>
      )}
      {note.comment && <p className="ac-note">{t("academy.results.trainerComment", { comment: note.comment })}</p>}
    </div>
  );
}
